import clsx from "clsx";
import React from "react";

interface Props {
  className?: string | null,
  children: React.ReactNode,
  // If id and title is set, this section will be added to contents list
  id?: string | undefined,
  contentsText?: string | null,
  contentsEmoji?: string | null,
}

const AdditionalInfoSection: React.FC<Props> = (
  {
    className = null,
    children = null,
    contentsText = null,
    contentsEmoji = null,
    id = undefined,
  }
) => {
  return (
    <section
      className={clsx(
        "flex flex-col gap-2 w-full py-2",
        className,
      )}
      id={id}
    >
      {children}
    </section>
  );
};

export default AdditionalInfoSection;